export enum CustomerManagedKeyEvent {
    ConfigEnabled = 'CMK.ConfigEnabled',
    ConfigDisabled = 'CMK.ConfigDisabled',
}
